import { createSelector } from 'reselect'

const couponItemsSelector = state => Object.keys(state.entities.coupons).map(id => state.entities.coupons[id])

export const punchCountSelector = createSelector(
    couponItemsSelector,
    items => items.reduce((acc, item) => acc + item.punchesLeft, 0)
)
